(() => {
  const roots = () => [...document.querySelectorAll('[data-fdp-family-links]')];

  function currentOptions(root) {
    return [1, 2, 3]
      .map((position) => root.dataset[`fdpCurrentOption${position}`])
      .filter((value) => value !== undefined && value !== '');
  }

  function matchingVariant(link, options) {
    const target = link.dataset.fdpFamilyTarget || '';
    const template = [...(link.parentElement?.querySelectorAll('template[data-fdp-family-target-variants]') || [])]
      .find((candidate) => candidate.dataset.fdpFamilyTargetVariants === target);
    if (!template) return null;
    return [...template.content.querySelectorAll('[data-fdp-family-variant-id]')].find((row) => {
      const count = Number(row.dataset.fdpFamilyOptionCount || 0);
      if (count !== options.length) return false;
      return options.every((value, index) => row.dataset[`fdpFamilyOption${index + 1}`] === value);
    }) || null;
  }

  function exactHref(link, variantId) {
    const sizeQuery = link.dataset.fdpFamilySizeChanged === '1' ? '&fdp_family_adjusted=size' : '';
    return `${link.dataset.fdpFamilyBaseUrl}?variant=${encodeURIComponent(variantId)}${sizeQuery}`;
  }

  function fallbackHref(link) {
    const adjustment = link.dataset.fdpFamilySizeChanged === '1' ? 'size-and-combination' : 'combination';
    return `${link.dataset.fdpFamilyBaseUrl}?fdp_family_adjusted=${adjustment}`;
  }

  function setLinkState(link, variant) {
    const exactLabel = link.dataset.fdpFamilyExactLabel || '';
    const fallbackLabel = link.dataset.fdpFamilyFallbackLabel || '';
    if (variant) {
      link.href = exactHref(link, variant.dataset.fdpFamilyVariantId);
      link.dataset.fdpFamilyMatch = 'exact';
      if (exactLabel) link.setAttribute('aria-label', exactLabel);
      return link.dataset.fdpFamilySizeChanged === '1';
    }
    link.href = fallbackHref(link);
    link.dataset.fdpFamilyMatch = 'fallback';
    if (fallbackLabel) link.setAttribute('aria-label', fallbackLabel);
    return true;
  }

  function updateRoot(root, options) {
    let adjusted = false;
    root.querySelectorAll('[data-fdp-family-link]').forEach((link) => {
      const variant = matchingVariant(link, options);
      if (setLinkState(link, variant)) adjusted = true;
    });
    const note = root.querySelector('[data-fdp-family-note]');
    if (note) note.hidden = !adjusted;
  }

  function updateSection(sectionId, options) {
    roots()
      .filter((root) => !sectionId || root.dataset.fdpSectionId === String(sectionId))
      .forEach((root) => updateRoot(root, options));
  }

  function prepareSectionChange(sectionId) {
    roots()
      .filter((root) => !sectionId || root.dataset.fdpSectionId === String(sectionId))
      .forEach((root) => updateRoot(root, []));
  }

  function showArrivalNotice() {
    if (typeof window === 'undefined' || typeof URLSearchParams === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const adjustment = params.get('fdp_family_adjusted');
    // Size messages remain for links/bookmarks created before same-size gaps became non-interactive.
    const messages = {
      size: '選んだカラーには同じキャッチサイズがないため、別のキャッチサイズのページへ移動しました。',
      combination: 'このページで選べる組み合わせに切り替わりました。',
      'size-and-combination': '選んだカラーには同じキャッチサイズがないため、別サイズのページで選べる組み合わせに切り替わりました。',
    };
    if (!messages[adjustment]) return;
    document.querySelectorAll('[data-fdp-family-arrival-note]').forEach((notice) => {
      notice.textContent = messages[adjustment];
      notice.hidden = false;
    });
  }

  function initialise() {
    roots().forEach((root) => updateRoot(root, currentOptions(root)));
    showArrivalNotice();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
        if (event?.data?.event?.isTrusted !== true) return;
        const productInfo = event?.data?.target?.closest?.('product-info');
        prepareSectionChange(productInfo?.dataset?.originalSection || productInfo?.dataset?.section);
      });
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event?.data?.variant;
        updateSection(event?.data?.sectionId, Array.isArray(variant?.options) ? variant.options.map(String) : []);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
